import { useState, useEffect, useCallback } from "react";
import {
  getClientMatters,
  getClientMatterInfo,
  getTasks,
  getMessages,
  addMessage,
} from "../../../api";

export const useFetchData = () => {
  const [matters, setMatters] = useState([]);
  const [matterInfo, setMatterInfo] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [messages, setMessages] = useState([]);
  const [selectedMatter, setSelectedMatter] = useState(null);

  useEffect(() => {
    const fetchMatters = async () => {
      try {
        const response = await getClientMatters();
        setMatters(response.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchMatters();
  }, []);

  const fetchMatterInfo = async (matterId) => {
    try {
      const response = await getClientMatterInfo(matterId);
      setMatterInfo(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchTasks = useCallback(
    async (matterId) => {
      try {
        const response = await getTasks(matterId);
        setTasks(response.data.data);
      } catch (err) {
        console.error(err);
      }
    },
    [selectedMatter]
  );

  const fetchMessages = useCallback(
    async (matterId) => {
      try {
        const response = await getMessages(matterId);
        const fetchedMessages =
          response.data?.data
            ?.filter((message) => message.isMessageOut)
            ?.map((message) => ({
              author: { id: 0, name: message?.senderUsername },
              text: message.message,
              timestamp: new Date(message.date),
            })) || [];

        const userMessages =
          response.data?.data
            ?.filter((message) => !message.isMessageOut)
            ?.map((message) => ({
              author: { id: 1, name: message?.senderUsername },
              text: message.message,
              timestamp: new Date(message.date),
            })) || [];

        const allMessages = [...fetchedMessages, ...userMessages];
        allMessages.sort((a, b) => a.timestamp - b.timestamp);

        setMessages(allMessages);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    },
    [selectedMatter]
  );

  const addNewMessage = useCallback(
    async (event) => {
      const userMessage = event.message;
      try {
        await addMessage(selectedMatter?.matterId, {
          message: userMessage?.text,
        });
        setMessages((prevMessages) => [...prevMessages, userMessage]);
      } catch (error) {
        console.error("Error sending message:", error);
      }
    },
    [selectedMatter?.matterId]
  );

  useEffect(() => {
    if (!selectedMatter) return;
    const { matterId } = selectedMatter;
    fetchMatterInfo(matterId);
    fetchTasks(matterId);
    fetchMessages(matterId);
  }, [selectedMatter]);

  return {
    matters,
    matterInfo,
    tasks,
    messages,
    selectedMatter,
    setSelectedMatter,
    fetchTasks,
    fetchMessages,
    addNewMessage,
  };
};
